import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NiceSelectModule } from "ng-nice-select";
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { CoreModule } from '@teem/core/core.module';
import { SharedModule } from '@teem/shared/shared.module';

import { PaymentsRoutingModule } from '@teem/payments-module/payments-routing.module';
import { PaymentsHeaderComponent } from '@teem/payments-module/components/payments-header/payments-header.component';
import { PaymentsTabHeaderComponent } from '@teem/payments-module/components/payments-tab-header/payments-tab-header.component';
import { PaymentsComponent } from '@teem/payments-module/payments.component';
import { RecordPaymentModalComponent } from '@teem/payments-module/modals/record-payment-modal/record-payment-modal.component';
import { InvoicesModule } from '@teem/invoices-module/invoices.module';

@NgModule({
  declarations: [
    PaymentsComponent,
    PaymentsHeaderComponent,
    PaymentsTabHeaderComponent,
    RecordPaymentModalComponent
  ],
  entryComponents: [
    RecordPaymentModalComponent
  ],
  imports: [
    NgbModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PaymentsRoutingModule,
    NiceSelectModule,
    SharedModule,
    CoreModule,
    InvoicesModule
  ]
})
export class PaymentsModule { }
